import classNames from "fg-frontend/src/lib/classNames";

export default (props, e) => {
	e.preventDefault();
	const target = document.querySelector('[data-is="ModalComponent"]');

	if (target) {
		classNames(target, {
			'modal--open': true,
		});
		classNames(document.body, {
			'modal__open': true,
		});
	}
};




// WEBPACK FOOTER //
// ./fe/web-career/src/js/webActions/openModal.js